// extracted by mini-css-extract-plugin
export default {"main":"Features_main__IL9C7","heading":"Features_heading__B8U7O","card":"Features_card__rsnPn","icon":"Features_icon__lLM00","description":"Features_description__4UxnK"};